import {
  initCoverage,
  getCoverageItems,
  getCoverage,
  getCoverageForEdit,
  saveCoverage,
  deleteCoverage,
  copyCoverage,
  exchangeConditionPriority,
  saveGetMax,
  getMaxForEdit,
  deleteGetMax,
  deleteAllMax,
} from "@/service";
import { commonMixin } from "@/mixins/common";
export default {
  mixins: [commonMixin],
  data() {
    const productData = JSON.parse(localStorage.productData);
    return {
      productData: productData,
      formularDataSelected: [],
      formularData: [],
      //客製化參數
      custom: {
        pageControl: [],
        defaultForm: [],
        needValidate: [],
      },
      pageControl: {
        pageName: "",
        pageBlock: ["period", "formula"],
        //設定頁籤
        settingType: 1,
        //保障條件
        parentCategoryName: "",
        coverageParentCategories: [],
        coverageTargets: [],
        coverageAnnuals: [],
        coverageCategories: [],
        coverageGoodWishList: [],
        coverageBenefitTypes: [],
        schemeItems: [],
        showScheme:
          productData.schemeData && productData.schemeData.length
            ? true
            : false,
        showHint: false,
        showAfter: true,
        showCoverageItems: true,
        showSecondaryCategory: false,
        showGoodWishList: false,
        showBenefitTypes: false,
        showRadioButtons: false,
        coverageItemsSortSeq: false,
        showPrimaryCategory: false,
        //保障期間
        coveragePeriodUnits: [],
        coveragePaymentPeriod: [],
        coveragePaymentExpiration: [],
        //保障公式
        calculationBasis: [],
        multiConditionBasis: [],
        fixedAmountBasis: [],
        maxCalculationBasis: [],
        formulaUnits: [
          {
            value: 1,
            text: "元",
          },
        ],
        noDollarUnits: [],
        interestTypes: [],
        formulaTrends: [],
        cumulativeFormulaMultipliers: [],
        appends: [],
        //是否顯示保障公式的上限欄位
        showUpper: true,
        //是否顯示翌日領取
        showNextDay: false,
      },
      form: {
        productId: productData.productId,
        //保障條件
        conditionId: "",
        duty: 1,
        annual: "all",
        year_type: 0,
        prd: 0,
        categoryId: "",
        sche_amt: 0,
        sche_nm: "all",
        goodWishId: "",
        benefitTypeId: "",
        othersId: "1",
        //保障期間
        periodId: "",
        periodType: 1,
        periodType_s: 7,
        begin: 1,
        beginUnit: 1,
        beginCondition: 0,
        end: 110,
        endUnit: 2,
        begin4: "",
        begin5: "",
        begin6: "",
        begin7: "",
        beginUnit4: 2,
        beginUnit5: 1,
        beginUnit6: 1,
        beginUnit7: 1,
        end3: "",
        end4: "",
        end5: "",
        endUnit3: 2,
        endUnit4: 2,
        endUnit5: 1,
        beginCondition1: 1,
        beginCondition2: 2,
        beginCondition3: 2,
        beginCondition4: 2,
        endCondition6: 2,
        //保障公式
        formulaId: "",
        formulaType: 1, //固定值
        calc_basis: "",
        period_lower: "",
        unit_lower: 1,
        period_upper: "",
        unit_upper: 1,
        benefit_max: "",
        position: [],
        position_s: "1",
        formulaId1: "",
        formulaId2: "",
        formulaId3: "",
        formulaId4: "",
        formulaId5: "",
        formulaId6: "",
        formulaId7: "",
        formulaId_s1: "",
        formulaId_s2: "",
        formulaId_s3: "",
        formulaId_s4: "",
        calc_basis1: 4,
        calc_basis2: 4,
        calc_basis3: 4,
        calc_basis4: 4,
        calc_basis5: 4,
        calc_basis6: 2,
        calc_basis_s1: "",
        calc_basis_s2: "",
        calc_basis_s4: "",
        period_lower1: 1,
        period_lower2: 1,
        period_lower3: 1,
        period_lower4: 1,
        period_lower5: 1,
        period_lower6: "",
        period_lower_s1: "",
        period_lower_s2: "",
        period_lower_s3: "",
        period_lower_s4: "",
        unit_lower1: 3,
        unit_lower2: 2,
        unit_lower3: 2,
        unit_lower4: 2,
        unit_lower5: 3,
        unit_lower6: 2,
        unit_lower_s1: 3,
        unit_lower_s2: 2,
        unit_lower_s3: 1,
        unit_lower_s4: 3,
        period_upper_s1: "",
        period_upper_s4: "",
        unit_upper_s1: 3,
        unit_upper_s4: 2,
        yearprogression2: 1,
        yearprogression3: 1,
        yearprogression4: 1,
        yearprogression5: 1,
        yearprogression6: 1,
        interestType2: "",
        interestType3: "",
        interestType4: "",
        interestType5: "",
        formulaTrend2: "",
        formulaTrend3: "",
        formulaTrend4: "",
        formulaTrend5: "",
        multiplier: 1,
        append: 1,
        guaranteepayage: "",
        age_limt: "",
        sche_amt_s3: 0,
        sche_amt_s4: 0,
        sche_nm_s3: "all",
        sche_nm_s4: "all",
        isNextDay: false,
        //編輯模式
        isEditMode: false,
        //取大設定
        getMaxId: "",
        //取大期間
        max_period: 1,
        year_after_start: "",
        max_start: "",
        max_start_unit: 1,
        max_end: "",
        max_end_unit: 1,
        //取大項目
        max_item: [],
        form_kind: "",
        basic_insurance_multiple: "",
        multiple_total_premium: "",
        total_premium_subtract_lifeannuity: "",
        insurance_amount_times: "",
        total_premium_times: "",
        add_multiple_total_premium: "",
      },
      validate: {
        isDutyErr: false,
        isPrdErr: false,
        isCategoryIdErr: false,
        isPrimaryCategoryErr: false,
        isPeriodTypeErr: false,
        isPeriodType_sErr: false,
        isBeginErr: false,
        isBeginUnitErr: false,
        isEndErr: false,
        isEndUnitErr: false,
        isCalc_basisErr: false,
        isPeriod_lowerErr: false,
        isUnit_lowerErr: false,
        isPeriod_upperErr: false,
        isPeriod_upperErr_s1: false,
        isPeriod_upperErr_s4: false,
        isUnit_upperErr: false,
        isBeginErr4: false,
        isBeginErr5: false,
        isBeginErr6: false,
        isBeginErr7: false,
        isBeginUnitErr4: false,
        isBeginUnitErr5: false,
        isBeginUnitErr6: false,
        isBeginUnitErr7: false,
        isEndErr3: false,
        isEndErr4: false,
        isEndErr5: false,
        isEndUnitErr3: false,
        isEndUnitErr4: false,
        isEndUnitErr5: false,
        isBegin_condErr1: false,
        isBegin_condErr2: false,
        isBegin_condErr3: false,
        isBegin_condErr4: false,
        isEnd_CondErr6: false,
        isPositionErr: false,
        isPosition_sErr: false,
        isCalc_basisErr1: false,
        isCalc_basisErr2: false,
        isCalc_basisErr3: false,
        isCalc_basisErr4: false,
        isCalc_basisErr5: false,
        isCalc_basisErr6: false,
        isCalc_basisErr_s1: false,
        isCalc_basisErr_s2: false,
        isCalc_basisErr_s4: false,
        isPeriod_lowerErr1: false,
        isPeriod_lowerErr2: false,
        isPeriod_lowerErr3: false,
        isPeriod_lowerErr4: false,
        isPeriod_lowerErr5: false,
        isPeriod_lowerErr6: false,
        isPeriod_lowerErr_s1: false,
        isPeriod_lowerErr_s2: false,
        isPeriod_lowerErr_s3: false,
        isPeriod_lowerErr_s4: false,
        isUnit_lowerErr1: false,
        isUnit_lowerErr2: false,
        isUnit_lowerErr3: false,
        isUnit_lowerErr4: false,
        isUnit_lowerErr_s1: false,
        isUnit_lowerErr_s2: false,
        isUnit_lowerErr_s3: false,
        isUnit_lowerErr_s4: false,
        isUnit_lowerErr5: false,
        isUnit_lowerErr6: false,
        isYear_progErr2: false,
        isYear_progErr3: false,
        isYear_progErr4: false,
        isYear_progErr5: false,
        isYear_progErr6: false,
        isInterestTypeErr2: false,
        isInterestTypeErr3: false,
        isInterestTypeErr4: false,
        isInterestTypeErr5: false,
        isFormulaTrend2: false,
        isFormulaTrend3: false,
        isFormulaTrend4: false,
        isFormulaTrend5: false,
        isMultiplierErr: false,
        isSche_amtErr_s3: false,
        isSche_amtErr_s4: false,
        isYearAfterStartErr: false,
        isMaxStartErr: false,
        isMaxEndErr: false,
        isBasic_insurance_multipleErr: false,
        isMultiple_total_premiumErr: false,
        isTotal_premium_subtract_lifeannuityErr: false,
        isInsurance_amount_timesErr: false,
        isTotal_premium_timesErr: false,
        isAdd_multiple_total_premiumErr: false,
      },
      //控制參數是否需要檢核
      needValidate: {
        duty: true,
        prd: true,
        categoryId: true,
        parentCategoryName: true,
        periodType: true,
        periodType_s: true,
        begin: true,
        beginUnit: true,
        end: true,
        endUnit: true,
        calc_basis: true,
        period_lower: true,
        unit_lower: true,
        period_upper: true,
        begin4: true,
        begin5: true,
        begin6: true,
        begin7: true,
        beginUnit4: true,
        beginUnit5: true,
        beginUnit6: true,
        beginUnit7: true,
        end3: true,
        end4: true,
        end5: true,
        endUnit3: true,
        endUnit4: true,
        endUnit5: true,
        beginCondition1: true,
        beginCondition2: true,
        beginCondition3: true,
        beginCondition4: true,
        beginCondition6: true,
        position: true,
        position_s: true,
        calc_basis1: true,
        calc_basis2: true,
        calc_basis3: true,
        calc_basis4: true,
        calc_basis5: true,
        calc_basis6: true,
        calc_basis_s1: true,
        calc_basis_s2: true,
        calc_basis_s4: true,
        period_lower1: true,
        period_lower2: true,
        period_lower3: true,
        period_lower4: true,
        period_lower5: true,
        period_lower6: true,
        period_lower_s1: true,
        period_lower_s2: true,
        period_lower_s3: true,
        period_lower_s4: true,
        unit_lower1: true,
        unit_lower2: true,
        unit_lower3: true,
        unit_lower4: true,
        unit_lower5: true,
        unit_lower6: true,
        unit_lower_s1: true,
        unit_lower_s2: true,
        unit_lower_s3: true,
        unit_lower_s4: true,
        period_upper_s1: true,
        period_upper_s4: true,
        yearprogression2: true,
        yearprogression3: true,
        yearprogression4: true,
        yearprogression5: true,
        yearprogression6: true,
        interestType2: true,
        interestType3: true,
        interestType4: true,
        interestType5: true,
        formulaTrend2: true,
        formulaTrend3: true,
        formulaTrend4: true,
        formulaTrend5: true,
        multiplier: true,
        sche_amt_s3: true,
        sche_amt_s4: true,
        max_period: true,
        year_after_start: true,
        max_start: true,
        max_end: true,
        basic_insurance_multiple: true,
        multiple_total_premium: true,
        total_premium_subtract_lifeannuity: true,
        insurance_amount_times: true,
        total_premium_times: true,
        add_multiple_total_premium: true,
      },
      maxItemDetails: [],
      defaultMaxItemDetail: {
        disabled: true,
        calculationbasis1: "0",
        calculationbasis1_value: "",
        operator: "0",
        calculationbasis2: "0",
        calculationbasis2_value: "",
        is_calculationbasis1_error: false,
        is_calculationbasis1_value_error: false,
        is_operator_error: false,
        is_calculationbasis2_error: false,
        is_calculationbasis2_value_error: false,
      }
    }
  },
  methods: {
    async init() {
      //塞入客製化參數
      Object.entries(this.custom.pageControl).forEach(([key, value]) => {
        this.pageControl[key] = value;
      });
      Object.entries(this.custom.needValidate).forEach(([key, value]) => {
        this.needValidate[key] = value;
      });

      if (this.pageControl.showScheme) {
        this.productData.schemeData.forEach((item) => {
          const obj = {
            value: item.quantity,
            text: item.name,
          };
          this.pageControl.schemeItems.push(obj);
        });
      }
      this.pageControl.coverageAnnuals = this.getCoverageAnnuals();
      if (this.pageControl.pageName === "其他保障") {
        await getCoverageItems().then((result) => {
          if (result.header && result.header.status == "200") {
            let filterCategory = [
              "傷害失能保險",
              "重大疾病",
              "長期看護",
              "癌症醫療",
              "疾病/意外醫療保險",
              "意外醫療",
              "意外身故",
              "燒燙傷保險金",
              "豁免保障",
              "婦女險",
              "醫療限額",
              "無",
            ];
            this.pageControl.coverageParentCategories = result.coverages
              .filter((item) => !item.parent)
              .map((item) => item["name"])
              .filter((item) => filterCategory.indexOf(item) == -1);
          } else {
            this.$toast.info({ title: result.header.message });
          }
        });
      }
      if (this.pageControl.coverageParentCategories.length == 0) {
        this.pageControl.coverageParentCategories.push(
          this.pageControl.pageName
        );
      }
      this.getInitData();
    },
    //=================call API=================
    getInitData() {
      const req = {
        hasParent: this.pageControl.showCoverageItems,
        parentCategoryName: this.pageControl.coverageParentCategories,
        block: this.pageControl.pageBlock,
        sortSeq: this.pageControl.coverageItemsSortSeq,
        productType: this.productData.productType,
      };
      initCoverage(req).then((result) => {
        if (result.header && result.header.status == "200") {
          this.pageControl.coverageTargets = result.data.coveragetargets;
          this.pageControl.coverageCategories = result.data.coveragecategories;
          if (this.pageControl.pageName === "其他保障") {
            let filterCategory = [
              "身故及完全失能保險金",
              "祝壽金",
              "生存保險金",
              "健康檢查保險金",
              "升學年金",
              "滿期保險金",
              "當年度保額",
            ];
            this.pageControl.coverageCategories = this.pageControl.coverageCategories.filter(
              (item) => filterCategory.indexOf(item.text) == -1
            );
          }
          this.pageControl.coverageGoodWishList =
            result.data.coveragegoodwishlist;
          this.pageControl.coverageBenefitTypes =
            result.data.coveragebenefittypes;
          this.pageControl.coveragePeriodUnits =
            result.data.coverageperiodunits;
          this.pageControl.coveragePaymentPeriod =
            result.data.coveragepaymentperiod;
          this.pageControl.coveragePaymentExpiration =
            result.data.coveragepaymentexpiration;
          this.pageControl.calculationBasis = result.data.calculationbasis;
          this.pageControl.multiConditionBasis =
            result.data.multiconditionbasis;
          this.pageControl.fixedAmountBasis = result.data.fixedamountbasis;
          this.pageControl.maxCalculationBasis = result.data.maxcalculationbasis;
          this.pageControl.maxOperator = result.data.maxoperator;
          this.pageControl.formulaUnits = result.data.formulaunits;
          this.pageControl.noDollarUnits = result.data.nodollarunits;
          this.pageControl.interestTypes = result.data.interesttypes;
          this.pageControl.formulaTrends = result.data.formulatrends;
          this.pageControl.cumulativeFormulaMultipliers =
            result.data.cumulativeformulamultipliers;
          this.pageControl.appends = result.data.appends;
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
      this.getFormularData();
    },
    //查詢列表資料
    getFormularData() {
      const req = {
        hasParent: this.pageControl.showCoverageItems,
        parentCategoryName: this.pageControl.coverageParentCategories,
        productId: this.productData.productId,
        productType: this.productData.productType,
      };
      getCoverage(req).then((result) => {
        if (result.header && result.header.status == "200") {
          this.formularData = result.data;
          this.formularDataSelected = [];
          this.resetForm();
          this.resetGetMaxForm();
        } else {
          this.formularData = [];
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    //儲存資料
    saveData(req) {
      saveCoverage(req).then((result) => {
        if (result.header && result.header.status == "200") {
          this.getFormularData();
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    //儲存取大設定資料
    saveMaxData(req) {
      saveGetMax(req).then((result) => {
        if (result.header && result.header.status == "200") {
          this.getFormularData();
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    //設定編輯資料
    async setFormData(data) {
      this.form.isEditMode = true;
      this.form.conditionId = data.conditionid;
      this.form.duty = Number(data.duty);
      this.form.prd = data.prd ? Number(data.prd) : 0;
      this.form.year_type = data.year_type;
      this.form.annual = this.getAnnnualStr(this.form);
      // 點擊編輯時，先依據 categoryId 設置母類別 parentCategoryName，確保選項列表先被載入
      if (data.categoryid && this.pageControl.coverageCategories) {
        const currentCat = this.pageControl.coverageCategories.find(
          (c) => c.value === data.categoryid
        );
        if (currentCat && currentCat.parent) {
          this.pageControl.parentCategoryName = currentCat.parent;
        }
      }
      this.form.categoryId = data.categoryid;
      if (!this.pageControl.showRadioButtons) {
        this.form.sche_amt = data.sche_amt ? data.sche_amt : 0;
        this.form.sche_nm = data.sche_nm ? data.sche_nm : "all";
      }

      //除了預設condition區塊，其他需於後端重新查詢
      if (this.pageControl.pageBlock.length) {
        const req = {
          conditionId: data.conditionid,
          periodId: data.periodid,
        };
        await getCoverageForEdit(req).then((result) => {
          if (result.header && result.header.status == "200") {
            //保障公式
            const formula = result.data.formula[0];
            if (
              (this.showPeriodSingle && this.showFormulaSingle) ||
              (this.showPeriodMulti && this.showFormulaMulti) ||
              (this.showPeriodGoodwish && this.showFormulaGoodwish)
            ) {
              if (this.pageControl.showRadioButtons) {
                this.form.othersId =
                  formula.formulatype == 1 || formula.formulatype == 3 ? 1 : 2;
              }
              if (this.form.goodWishId) {
                this.form.goodWishId = formula.formulatype == 7 ? 1 : 2;
              }
              if (this.form.goodWishId && this.form.goodWishId == 1) {
                this.pageControl.pageBlock = [
                  "periodGoodwish",
                  "formulaGoodwish",
                  "maxSingle",
                ];
                //保障期間
                const coverageperiod = result.data.coverageperiod;
                this.form.periodId = coverageperiod.coverageperiodid;
                this.form.periodType = coverageperiod.coverageperiodtype;
                if (this.form.periodType == 4) {
                  this.form.begin = coverageperiod.beginpoint;
                  this.form.beginUnit = coverageperiod.beginunit;
                }

                //保障公式
                this.form.formulaId = formula.formulaid;
                this.form.calc_basis = formula.calc_basis;
                this.form.period_lower = formula.period_lower;
                this.form.unit_lower = formula.unit_lower;
                this.form.period_upper = formula.period_upper;
                this.form.unit_upper = formula.unit_upper;
              } else if (
                this.pageControl.showRadioButtons &&
                this.form.othersId == 1
              ) {
                this.pageControl.pageBlock = ["periodSingle", "formulaSingle"];

                //保障期間
                const coverageperiod = result.data.coverageperiod;
                this.form.periodId = coverageperiod.coverageperiodid;
                this.form.periodType_s = coverageperiod.coverageperiodtype;
                if (this.form.periodType_s == 1) {
                  this.form.begin = coverageperiod.beginpoint;
                  this.form.beginUnit = coverageperiod.beginunit;
                  this.form.end = coverageperiod.endpoint;
                  this.form.endUnit = coverageperiod.endunit;
                }

                //保障公式
                this.form.position_s = formula.position;
                if (this.form.position_s == 1) {
                  this.form.formulaId_s1 = formula.formulaid;
                  this.form.calc_basis_s1 = formula.calc_basis;
                  this.form.period_lower_s1 = formula.period_lower;
                  this.form.unit_lower_s1 = formula.unit_lower;
                  this.form.period_upper_s1 = formula.period_upper;
                  this.form.unit_upper_s1 = formula.unit_upper;
                } else if (this.form.position_s == 0) {
                  this.form.formulaId_s2 = formula.formulaid;
                  this.form.calc_basis_s2 = formula.calc_basis;
                  this.form.period_lower_s2 = formula.period_lower;
                  this.form.unit_lower_s2 = formula.unit_lower;
                  this.form.benefit_max = this.numFormat(formula.max_bnf_limt);
                } else if (this.form.position_s == 3) {
                  this.form.formulaId_s3 = formula.formulaid;
                  this.form.period_lower_s3 = formula.period_lower;
                  this.form.unit_lower_s3 = formula.unit_lower;
                  this.form.sche_amt_s3 = data.sche_amt ? data.sche_amt : 0;
                  this.form.sche_nm_s3 = data.sche_nm ? data.sche_nm : "all";
                } else if (this.form.position_s == 4) {
                  this.form.formulaId_s4 = formula.formulaid;
                  this.form.calc_basis_s4 = formula.calc_basis;
                  this.form.period_lower_s4 = formula.period_lower;
                  this.form.unit_lower_s4 = formula.unit_lower;
                  this.form.period_upper_s4 = formula.period_upper;
                  this.form.unit_upper_s4 = formula.unit_upper;
                  this.form.sche_amt_s4 = data.sche_amt ? data.sche_amt : 0;
                  this.form.sche_nm_s4 = data.sche_nm ? data.sche_nm : "all";
                }
              } else {
                if (
                  this.pageControl.pageName === "當年度保額" ||
                  this.pageControl.pageName === "其他保障"
                ) {
                  this.pageControl.pageBlock = ["periodMulti", "formulaMulti"];
                } else if (
                  this.pageControl.pageName === "身故及完全失能保險金"
                ) {
                  this.pageControl.pageBlock = [
                    "periodMulti",
                    "formulaMulti",
                    "maxMulti",
                  ];
                } else {
                  this.pageControl.pageBlock = [
                    "periodMulti",
                    "formulaMulti",
                    "maxSingle",
                  ];
                }
                //保障期間
                const coverageperiod = result.data.coverageperiod;
                this.form.periodId = coverageperiod.coverageperiodid;
                this.form.periodType = coverageperiod.coverageperiodtype;
                switch (this.form.periodType) {
                  case 7: {
                    this.form.beginCondition1 = coverageperiod.begincondition;
                    break;
                  }
                  case 8: {
                    this.form.beginCondition2 = coverageperiod.begincondition;
                    break;
                  }
                  case 2: {
                    this.form.beginCondition3 = coverageperiod.begincondition;
                    this.form.end3 = coverageperiod.endpoint;
                    this.form.endUnit3 = coverageperiod.endunit;
                    break;
                  }
                  case 5: {
                    this.form.beginCondition4 = coverageperiod.begincondition;
                    this.form.begin4 = coverageperiod.beginpoint;
                    this.form.beginUnit4 = coverageperiod.beginunit;
                    this.form.end4 = coverageperiod.endpoint;
                    this.form.endUnit4 = coverageperiod.endunit;
                    break;
                  }
                  case 1: {
                    this.form.begin5 = coverageperiod.beginpoint;
                    this.form.beginUnit5 = coverageperiod.beginunit;
                    this.form.end5 = coverageperiod.endpoint;
                    this.form.endUnit5 = coverageperiod.endunit;
                    break;
                  }
                  case 3: {
                    this.form.endCondition6 = coverageperiod.endcondition;
                    this.form.begin6 = coverageperiod.beginpoint;
                    this.form.beginUnit6 = coverageperiod.beginunit;
                    break;
                  }
                  case 4: {
                    this.form.begin7 = coverageperiod.beginpoint;
                    this.form.beginUnit7 = coverageperiod.beginunit;
                    break;
                  }
                }
                if (this.pageControl.showNextDay) {
                  this.form.isNextDay =
                    coverageperiod.hasnextday == 2 ? true : false;
                }

                //保障公式
                result.data.formula.forEach((item) => {
                  // LICRMPA-4857: 多行型公式，點擊編輯時反填給付方式 (bnf_type)
                  if (item.bnf_type && this.pageControl.showBenefitTypes) {
                    this.form.benefitTypeId = item.bnf_type;
                  }
                  if (item.position == 0) {
                    if (item.formulatype == 8) {
                      this.form.position.push("0");
                      this.form.formulaId1 = item.formulaid;
                      this.form.calc_basis1 = item.calc_basis;
                      this.form.unit_lower1 = item.unit_lower;
                      this.form.period_lower1 = formula.period_lower;
                      this.form.benefit_max = this.numFormat(formula.max_bnf_limt);
                    } else if (item.formulatype == 5) {
                      this.form.position.push("6");
                      this.form.formulaId7 = item.formulaid;
                      this.form.append = item.append;
                    }
                  } else if (item.position == 1) {
                    this.form.position.push("1");
                    this.form.formulaId2 = item.formulaid;
                    this.form.yearprogression2 = item.yearprogression;
                    this.form.calc_basis2 = item.calc_basis;
                    this.form.interestType2 = item.interesttype
                      ? item.interesttype
                      : "";
                    this.form.period_lower2 = item.value;
                    this.form.unit_lower2 = item.unit_lower;
                    this.form.formulaTrend2 = item.formulatrend
                      ? item.formulatrend
                      : "";
                  } else if (item.position == 2) {
                    this.form.position.push("2");
                    this.form.formulaId3 = item.formulaid;
                    this.form.yearprogression3 = item.yearprogression;
                    this.form.calc_basis3 = item.calc_basis;
                    this.form.interestType3 = item.interesttype
                      ? item.interesttype
                      : "";
                    this.form.period_lower3 = item.value;
                    this.form.unit_lower3 = item.unit_lower;
                    this.form.formulaTrend3 = item.formulatrend
                      ? item.formulatrend
                      : "";
                  } else if (item.position == 3) {
                    this.form.position.push("3");
                    this.form.formulaId4 = item.formulaid;
                    this.form.yearprogression4 = item.yearprogression;
                    this.form.calc_basis4 = item.calc_basis;
                    this.form.interestType4 = item.interesttype
                      ? item.interesttype
                      : "";
                    this.form.period_lower4 = item.value;
                    this.form.unit_lower4 = item.unit_lower;
                    this.form.formulaTrend4 = item.formulatrend
                      ? item.formulatrend
                      : "";
                  } else if (item.position == 4) {
                    this.form.position.push("4");
                    this.form.formulaId5 = item.formulaid;
                    this.form.yearprogression5 = item.yearprogression;
                    this.form.calc_basis5 = item.calc_basis;
                    this.form.interestType5 = item.interesttype
                      ? item.interesttype
                      : "";
                    this.form.period_lower5 = item.value;
                    this.form.unit_lower5 = item.unit_lower;
                    this.form.formulaTrend5 = item.formulatrend
                      ? item.formulatrend
                      : "";
                  } else if (item.position == 5) {
                    this.form.position.push("5");
                    this.form.formulaId6 = item.formulaid;
                    this.form.yearprogression6 = item.yearprogression;
                    this.form.calc_basis6 = item.calc_basis;
                    this.form.interestType6 = item.interesttype
                      ? item.interesttype
                      : "";
                    this.form.period_lower6 = item.value;
                    this.form.unit_lower6 = item.unit_lower;
                    this.form.formulaTrend6 = item.formulatrend
                      ? item.formulatrend
                      : "";
                    this.form.multiplier = item.multiplier
                      ? item.multiplier
                      : "";
                  }
                });

                //保證給付年齡
                const guaranteepayage = result.data.guaranteepayage;
                if (guaranteepayage) {
                  this.form.guaranteepayage = guaranteepayage;
                } else {
                  this.form.guaranteepayage = "";
                }
              }
            } else {
              //保障期間
              const coverageperiod = result.data.coverageperiod;
              this.form.periodId = coverageperiod.coverageperiodid;
              this.form.periodType = coverageperiod.coverageperiodtype;
              if (this.form.periodType == 1) {
                this.form.begin = coverageperiod.beginpoint;
                this.form.beginUnit = coverageperiod.beginunit;
                this.form.end = coverageperiod.endpoint;
                this.form.endUnit = coverageperiod.endunit;
              }

              //保障公式
              this.form.formulaId = formula.formulaid;
              this.form.calc_basis = formula.calc_basis;
              this.form.period_lower = formula.period_lower;
              this.form.unit_lower = formula.unit_lower;
              this.form.period_upper = formula.period_upper;
              this.form.unit_upper = formula.unit_upper;
              if (this.pageControl.showBenefitTypes) {
                this.form.benefitTypeId = formula.bnf_type;
                this.form.benefit_max = this.numFormat(formula.max_bnf_limt);
              }
            }
            //保證給付年齡
            const age_limt = result.data.age_limt;
            if (age_limt) {
              this.form.age_limt = age_limt;
            } else {
              this.form.age_limt = "";
            }
          } else {
            this.$toast.info({ title: result.header.message });
          }
        });
      }
    },
    //取大設定編輯資料
    async setMaxFormData(data) {
      this.form.getMaxId = data.getmaxid;

      //後端查詢取大編輯資訊
      if (this.form.getMaxId) {
        const req = {
          GET_MAX_ID: data.getmaxid,
          IS_CUSTOM: this.showMaxCustom,
        };
        await getMaxForEdit(req).then((result) => {
          if (result.header && result.header.status == "200") {
            //取大設定資料
            const getMax = result.data.getmax;
            
            this.form.categoryId = getMax.coveragecategoryid;
            this.form.max_period = getMax.get_max_period;
            if (getMax.year_after_start) {
              this.form.year_after_start = getMax.year_after_start;
            }
            this.form.max_start = getMax.start;
            if (getMax.start_unit) {
              this.form.max_start_unit = getMax.start_unit;
            }
            this.form.max_end = getMax.end;
            if (getMax.end_unit) {
              this.form.max_end_unit = getMax.end_unit;
            }
            this.form.prd = getMax.prd ? Number(data.prd) : 0;
            this.form.year_type = getMax.year_type;
            this.form.annual = this.getAnnnualStr(this.form);
            //取大項目
            if (typeof getMax.get_max_item === 'string') {
              this.form.max_item = getMax.get_max_item.split(",");
            } if (typeof getMax.get_max_item === 'object') {
              let get_max_item = getMax.get_max_item;
              this.setMaxItemDetails(get_max_item);
              this.form.max_item = [];
              for (let i = 0; i < get_max_item.length; i++) 
                this.form.max_item.push(i);
            }
            this.form.basic_insurance_multiple =
              getMax.basic_insurance_multiple;
            this.form.multiple_total_premium = getMax.multiple_total_premium;
            this.form.total_premium_subtract_lifeannuity =
              getMax.total_premium_subtract_lifeannuity;
            this.form.insurance_amount_times = getMax.insurance_amount_times;
            this.form.total_premium_times = getMax.total_premium_times;
            this.form.add_multiple_total_premium =
              getMax.add_multiple_total_premium;
          } else {
            this.$toast.info({ title: result.header.message });
          }
        });
      }
    },
    setMaxItemDetails(get_max_item) {
      this.maxItemDetails = [];
      [ ...Array(5) ].forEach((e, index) => {
        let detail = JSON.parse(JSON.stringify(this.defaultMaxItemDetail));

        if (index < get_max_item.length) {
          detail.calculationbasis1 = get_max_item[index].calculationbasis1;
          detail.calculationbasis1_value = get_max_item[index].calculationbasis1_value;
          detail.operator = get_max_item[index].operator;
          detail.calculationbasis2 = get_max_item[index].calculationbasis2;
          detail.calculationbasis2_value = get_max_item[index].calculationbasis2_value;
        }
        detail.disabled = index > get_max_item.length;
        this.maxItemDetails.push(detail);
      });
    },
    //載入取大設定資料
    async getMaxFormData(getMaxId) {
      //後端查詢取大編輯資訊
      if (getMaxId) {
        const req = {
          GET_MAX_ID: getMaxId,
        };
        await getMaxForEdit(req).then((result) => {
          if (result.header && result.header.status == "200") {
            //取大設定資料
            const getMax = result.data.getmax;

            this.form.max_period = getMax.get_max_period;
            this.form.year_after_start = getMax.year_after_start;
            this.form.max_start = getMax.start;
            if (getMax.start_unit) {
              this.form.max_start_unit = getMax.start_unit;
            }
            this.form.max_end = getMax.end;
            if (getMax.end_unit) {
              this.form.max_end_unit = getMax.end_unit;
            }
            //取大項目
            if (getMax.get_max_item) {
              this.form.max_item = getMax.get_max_item.split(",");
            } else {
              this.form.max_item = [];
            }
          } else {
            this.$toast.info({ title: result.header.message });
          }
        });
      }
      //載入FORM8返回前取大設定
      this.setbeforeRouteFrom8Setting();
    },
    //刪除資料
    deleteCoverage(req) {
      deleteCoverage(req).then((result) => {
        if (result.header && result.header.status == "200") {
          this.getFormularData();
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    //刪除取大設定資料
    deleteGetMax(req) {
      deleteGetMax(req).then((result) => {
        if (result.header && result.header.status == "200") {
          this.getFormularData();
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    //刪除取大設定及FORM資料
    deleteAllMax(req) {
      deleteAllMax(req).then((result) => {
        if (result.header && result.header.status == "200") {
          this.getFormularData();
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    //複製資料
    copyCoverage(req) {
      copyCoverage(req).then((result) => {
        if (result.header && result.header.status == "200") {
          this.getFormularData();
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    //交換順序
    exchangeConditionPriority(req) {
      exchangeConditionPriority(req).then((result) => {
        if (result.header && result.header.status == "200") {
          this.getFormularData();
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    //重設表單
    async resetForm() {
      this.form = await this.$options.data().form;

      //重設保障項目
      if (this.pageControl.coverageCategories.length > 0) {
        if (this.pageControl.pageName === "祝壽金") {
          this.form.categoryId = this.pageControl.coverageCategories[0].value;
          this.form.goodWishId = this.pageControl.coverageGoodWishList[0].value;
        } else {
          if (this.pageControl.parentCategoryName) {
            this.form.categoryId = this.pageControl.coverageCategories.filter(
              (item) => item.parent == this.pageControl.parentCategoryName
            )[0].value;
            if (this.pageControl.parentCategoryName === "其他保障"){
              this.form.categoryId=''
            }
          }
        }
      }

      //塞入預設
      Object.entries(this.custom.defaultForm).forEach(([key, value]) => {
        this.form[key] = value;
        if(key == 'unit_lower'){
          this.form['unit_upper'] = value;
        }
      });
      //塞入客製化參數
      Object.entries(this.custom.pageControl).forEach(([key, value]) => {
        this.pageControl[key] = value;
      });

      //載入取大設定
      if (this.hasGetMax && this.showMaxSingle) {
        const getmaxid = this.formularData.filter(
          (item) => !item.conditionid
        )[0].getmaxid;
        this.getMaxFormData(getmaxid);
      } else {
        this.setbeforeRouteFrom8Setting();
      }
    },
    //載入FORM8返回前取大設定
    setbeforeRouteFrom8Setting() {
      if (
        this.RouterPara.filterResult &&
        this.RouterPara.filterResult.length > 0 &&
        this.RouterPara.filterResult[0].hasOwnProperty("isEditMode")
      ) {
        this.RouterPara.filterResult.forEach((item) => {
          this.setGetMaxForm(item);
        });
        this.$store.dispatch("setRouterPara", {
          pathName: "filterResult",
          setData: "",
        });
      }
    },
    //載入取大表單
    setGetMaxForm(item) {
      this.form.isEditMode = item.isEditMode;
      this.form.getMaxId = item.getMaxId;
      //取大期間
      this.form.max_period = item.max_period;
      if (item.hasOwnProperty("year_after_start")) {
        this.form.year_after_start = item.year_after_start;
      }
      this.form.max_start = item.max_start;
      this.form.max_start_unit = item.max_start_unit;
      this.form.max_end = item.max_end;
      this.form.max_end_unit = item.max_end_unit;
      //取大項目
      if (item.max_item) {
        this.form.max_item = item.max_item;
      } else {
        this.form.max_item = [];
      }
      if (item.hasOwnProperty("basic_insurance_multiple")) {
        this.form.basic_insurance_multiple = item.basic_insurance_multiple;
        this.form.multiple_total_premium = item.multiple_total_premium;
        this.form.total_premium_subtract_lifeannuity =
          item.total_premium_subtract_lifeannuity;
        this.form.insurance_amount_times = item.insurance_amount_times;
        this.form.total_premium_times = item.total_premium_times;
        this.form.add_multiple_total_premium = item.add_multiple_total_premium;
      }
    },
    //重設取大表單(僅 身故及完全失能保險金 使用)
    resetGetMaxForm() {
      this.form = this.$options.data().form;
      this.form.isEditMode = false;
      this.form.getMaxId = "";
      //重設保障項目
      if (this.pageControl.coverageCategories.length > 0) {
        if (this.pageControl.pageName === "祝壽金") {
          this.form.categoryId = this.pageControl.coverageCategories[0].value;
          this.form.goodWishId = this.pageControl.coverageGoodWishList[0].value;
        } else {
          if (this.pageControl.parentCategoryName) {
            this.form.categoryId = this.pageControl.coverageCategories.filter(
              (item) => item.parent == this.pageControl.parentCategoryName
            )[0].value;
            if (this.pageControl.parentCategoryName === "其他保障"){
              this.form.categoryId=''
            }
          }
        }
      }
      //取大期間
      this.form.max_period = "";
      this.form.max_start = "";
      this.form.max_start_unit = 1;
      this.form.max_end = "";
      this.form.max_end_unit = 1;
      //取大項目
      this.form.max_item = [];
      this.form.basic_insurance_multiple = "";
      this.form.multiple_total_premium = "";
      this.form.total_premium_subtract_lifeannuity = "";
      this.form.insurance_amount_times = "";
      this.form.total_premium_times = "";
      this.form.add_multiple_total_premium = "";
      this.maxItemDetails = [];
      this.getMaxCustomInit();
    },
    //取得年期清單
    getCoverageAnnuals() {
      const productData = JSON.parse(localStorage.productData);
      const res = [];
      productData.maturityType.filter((item) => item.check).forEach((item) => {
        const obj = {
          value: parseInt(item.year) + "歲",
          text: parseInt(item.year) + "歲",
        };
        res.push(obj);
      });

      productData.regularType.filter((item) => item.check).forEach((item) => {
        const obj = {
          value: parseInt(item.year) + "年期",
          text: parseInt(item.year) + "年期",
        };
        res.push(obj);
      });
      return res;
    },
    getAnnnualStr(data) {
      switch (Number(data.year_type)) {
        case 0:
          return "all";
        case 1:
          return data.prd + "年期";
        case 2:
          return data.prd + "歲";
        default:
          return "";
      }
    },
    numFormat(num = 0) {
      // 組合保額 and 保額單位
      let number = Number(num);
      number = number / 10000;
      return number ? number : "";
    },
  },
};
